export class Preference {
    public preferenceId: number;
    public prefType: string;
    public dataTableId: string;
    public configuration: any;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/models/preference.model.ts